const initialState = {
  webinars: [],
  filterYearWebinars: null,
};

const GET_WEBINARS = 'GET_WEBINARS';
const SET_YEAR_FILTER_WEBINARS = 'SET_YEAR_FILTER_WEBINARS';

export const webinarsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WEBINARS:
      return { ...state, webinars: action.payload };
    case SET_YEAR_FILTER_WEBINARS:
      return { ...state, filterYearWebinars: action.payload };
    default:
      return state;
  }
};

export const getWebinarsAction = (payload) => ({ type: GET_WEBINARS, payload });
export const setYearFilterWebinars = (year) => ({
  type: SET_YEAR_FILTER_WEBINARS,
  payload: year,
});
